import PropTypes from 'prop-types';
import cx from 'classnames';

import withTheme from 'core/hocs/withTheme';

import styles from './index.styl';


function Skeleton({ theme, titleHeight, leadHeight }) {
  const atoms = theme.controls.topicHeaderTexts;

  return (
    <div className='content'>
      <style jsx>{`
        .content
          margin-bottom ${atoms.marginBottom}px
        .${styles.divider}
          margin ${(atoms.divider && atoms.divider.margin) || 0}
          background ${atoms.divider && atoms.divider.background}

        .${styles.title}
          height ${titleHeight}px

        .${styles.lead}
          height ${leadHeight}px
          margin-top ${atoms.divider ? 0 : `${atoms.lead.top}px`}
      `}</style>
      <div className={cx('lb-skeleton', styles.title)} />
      {atoms.divider && (
        <div className={styles.divider} />
      )}
      <div className={cx('lb-skeleton', styles.lead)} />
    </div>
  );
}

Skeleton.propTypes = {
  titleHeight: PropTypes.number,
  leadHeight: PropTypes.number,
  theme: PropTypes.object,
};

Skeleton.defaultProps = {
  titleHeight: 30,
  leadHeight: 30,
};

export default withTheme(Skeleton);
